import React, { useState } from "react";
import {
  Box,
  Menu,
  MenuItem,
  Collapse,
  IconButton,
  Typography,
} from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import { setStartDate, setEndDate, setSelected } from "../Redux/reportSlice";

const CustomDateRangePicker = ({
  name,
  setTempStartDate,
  setTempEndDate,
  anchorEl,
  handleClose,
}) => {
  const dispatch = useDispatch();
  const [expandedYears, setExpandedYears] = useState({});
  const currentYear = dayjs().year();
  const currentMonth = dayjs().month();
  const startYear = 2025;
  const startMonth = 0;

  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  );

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const handleDateChange = (year, monthIndex) => {
    const date = dayjs(`${year}-${monthIndex + 1}-01`);
    const startOfMonth = date.startOf("month");
    const endOfMonth = date.endOf("month");

    dispatch(setStartDate(startOfMonth));
    dispatch(setEndDate(endOfMonth));
    dispatch(setSelected(""));
    setTempStartDate(startOfMonth);
    setTempEndDate(endOfMonth);

    handleClose();
  };

  const toggleYear = (year) => {
    setExpandedYears((prev) => ({
      ...prev,
      [year]: !prev[year],
    }));
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      MenuListProps={{ sx: { maxHeight: 400, width: 150 } }}
    >
      {years.map((year) => (
        <Box key={year}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              padding: "8px 16px",
              fontWeight: "bold",
              background: "#f5f5f5",
              color:
                year < startYear || year > currentYear ? "#bdbdbd" : "black",
              cursor:
                year >= startYear && year <= currentYear
                  ? "pointer"
                  : "default",
            }}
            onClick={() =>
              year >= startYear && year <= currentYear && toggleYear(year)
            }
          >
            <Typography>{year}</Typography>
            <IconButton
              size="small"
              disabled={year < startYear || year > currentYear}
            >
              {expandedYears[year] ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </Box>

          <Collapse in={expandedYears[year]}>
            {months.map((month, index) => {
              const isDisabled =
                (year === startYear && index < startMonth) || // Disable months before Jan 2025
                (year === currentYear && index > currentMonth) || // Disable future months in current year
                (name === "Invoice" && index === currentMonth);

              return (
                <MenuItem
                  key={index}
                  onClick={() => !isDisabled && handleDateChange(year, index)}
                  disabled={isDisabled}
                  sx={{
                    color: isDisabled ? "#bdbdbd" : "black",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  {month} {year}
                </MenuItem>
              );
            })}
          </Collapse>
        </Box>
      ))}
    </Menu>
  );
};

export default CustomDateRangePicker;
